<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>
<p>This is an alert message to display when no data is found</p>
<p>It can be styled in different ways. We usually show the "No Data" alert when filters result in no match,
but a placeholder option (jbIsPlaceholder = true) when a list of items is empty (no filters applied)</p>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>

<!--<div class="row">-->
<!--  <div class="col-3">-->
<!--    <jb-no-data></jb-no-data>-->
<!--  </div>-->
<!--</div>-->

<!--<div class="row whiteBg">-->
<!--  <jb-no-data class="col-12 size-lg"-->
<!--              [jbIsPlaceholder]="true"-->
<!--              jbIcon="icon-hour-glass"-->
<!--              jbTitle="No Items yet"-->
<!--              jbDescription="Click to add a new item."-->
<!--  ></jb-no-data>-->
<!--</div>-->


<!--jb-no-data Customization-->
<div class="whiteBg">
  <div class="row">
    <div class="col-5 marB15">
      <h5 class="marB25">jb-no-data Customization:</h5>


      <div class="marT15">
        <div class="code-box pad15">
          <pre>{{customCompCode}}</pre>
        </div>
      </div>
    </div>

    <div class="col-7">

      <div class="row marT15">
        <div class="col-4 padT5">
          <jb-switch [(ngModel)]="compConf.isPlaceholder" (ngModelChange)="upComp()"
                     jbLabelPos="left" jbLabel="Is Empty List Placeholder" jbOnText="Yes" jbOffText="No">
          </jb-switch>
        </div>
        <div class="col-4 padT5" *ngIf="compConf.isPlaceholder">
          <jb-dropdown jbLabel="jbIcon" [(ngModel)]="compConf.jbIcon" (ngModelChange)="upComp()"
                       [jbList]="iconList" jbRender="icon" jbSelect="icon"
          ></jb-dropdown>
        </div>
        <jb-input class="col-4 padT25" [(ngModel)]="compConf.jbIcon" (ngModelChange)="upComp()"></jb-input>
      </div>

      <div class="row marT15" *ngIf="!compConf.isPlaceholder">
        <div class="col-4 padT5"> <jb-checkbox [(ngModel)]="compConf.hasLabel" (ngModelChange)="upComp()" jbLabel="Has Label"></jb-checkbox> </div>
        <div class="col-8" style="margin-bottom: -5px;" *ngIf="compConf.hasLabel">
          <jb-input [(ngModel)]="compConf.jbMessage" (ngModelChange)="upComp()"></jb-input>
        </div>
      </div>

      <div class="row marT15" *ngIf="compConf.isPlaceholder">
        <div class="col-6" style="margin-bottom: -5px;">
          <jb-input jbLabel="jbTitle" [(ngModel)]="compConf.jbTitle" (ngModelChange)="upComp()"></jb-input>
        </div>
        <div class="col-6" >
          <jb-input jbLabel="jbDescription" [(ngModel)]="compConf.jbDescription" (ngModelChange)="upComp()"></jb-input>
        </div>

        <div class="col-12">
          <jb-label class="marR15" jbText="Css Size Class"></jb-label>
          <jb-radio [(ngModel)]="compConf.sizeClass" jbLabel="size-xl" jbValue="size-xl" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio [(ngModel)]="compConf.sizeClass" jbLabel="size-lg" jbValue="size-lg" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio [(ngModel)]="compConf.sizeClass" jbLabel="size-md" jbValue="size-md" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio [(ngModel)]="compConf.sizeClass" jbLabel="size-sm" jbValue="size-sm" (ngModelChange)="upComp()"></jb-radio>
          <jb-radio [(ngModel)]="compConf.sizeClass" jbLabel="size-xs" jbValue="size-xs" (ngModelChange)="upComp()"></jb-radio>
        </div>
      </div>

    </div>

  </div>
</div>


<div class="row whiteBg">
  <jb-no-data [jbMessage]="compConf.hasLabel ? compConf.jbMessage : 'view.common.no_data_to_show'"
              class="col-12" [ngClass]="compConf.sizeClass"
              [jbIsPlaceholder]="compConf.isPlaceholder"
              [jbIcon]="compConf.jbIcon"
              [jbTitle]="compConf.jbTitle"
              [jbDescription]="compConf.jbDescription"
  ></jb-no-data>
</div>
<hr>




<h5 class="mt-4">Examples:</h5>
<div class="col-12 examples-table">
  
  <div class="row">
    <div class="col-5">
      <jb-no-data></jb-no-data>
    </div>
    <div class="col-7"> <pre>{{instance}}</pre> </div>
  </div>
  
  <div class="row">
    <div class="col-5">
      <jb-no-data [jbIsPlaceholder]="true"
                  jbIcon="icon-tape"
                  jbTitle="view.voicemails.no_voicemails_title"
                  jbDescription="view.voicemails.no_voicemails">
      </jb-no-data>
    </div>
    <div class="col-7"> <pre>{{instance2}}</pre> </div>
  </div>

</div>



<!--CSS Styling-->
<div class="row marT40">
  <div class="col-12">
    <hr>
    <h4>CSS Styling</h4>
    <p>The following SASS variables can be overridden to provide customized coloring:</p>
    <pre class="padL30">{{ cssReset }}</pre>
  </div>
</div>

